<template>
  <v-section
    class="c-section--collection"
    :scale="{ x: 2, y: 1, z: 1 }"
  >
    <template #default="{ products }">
      <ui-tile
        v-for="product in products"
        :key="product.id"
        :product="product"
        class="c-tile--collection"
        :image-type="ImageType.POSTER"
        :layout="TileLayout.TRAILER"
      ></ui-tile>
    </template>
    <template #headerLeft>
      <slot name="headerLeft"></slot>
    </template>
    <template #headerRight>
      <slot name="headerRight"></slot>
    </template>
  </v-section>
</template>
<script>
  import { ImageType, TileLayout } from '@/shared/enums';
  import { VSection } from '@/index/shared/components';
  import UiTile from '../../tile/index.vue';

  export default {
    components: {
      UiTile,
      VSection,
    },
    enums: {
      ImageType,
      TileLayout,
    },
  };
</script>
